const ORG_SETTINGS_MODAL_KEY = 'pieve.org-settings';

export default ORG_SETTINGS_MODAL_KEY;
